const ROUTE_FILTER_KEYS = [
  "attention_user_id",
  "status",
  "planner_id",
  "planner",
  "primary_es_id",
  "es",
  "organisation_id",
  "organisation",
];

export const getPackRegisterRouteFilters = ({ search = "", state = null } = {}) => {
  const filters = {};
  const urlFilters = new URLSearchParams(search);

  ROUTE_FILTER_KEYS.forEach((key) => {
    if (state?.[key]) filters[key] = state[key];
    if (urlFilters.get(key)) filters[key] = urlFilters.get(key);
  });

  return filters;
};
